class BgParallax {
  constructor(element) {
    if (!element) {
      return false;
    }    

    this.parallax = jQuery(element);      
    this._iniParallax();       
  }

  _iniParallax () {
    const image =  document.getElementsByClassName('s-bg-parallax__thumbnail');

    new simpleParallax(image,{
      delay: 2,
      orientation: 'down',
      maxTransition:99,
      transition: 'cubic-bezier(0,0,0,1)'
    });
  }
  
 
}
export default BgParallax;
